<template>
	<div class="floats df wao hao" v-if="type">
		<!-- 选择规格 -->
		<div class="box df hal chooseSpec" v-if="type=='chooseSpec'">
			<div class="close" @click="tapClose"></div>
			<img :src="data.img" alt="">
			<div class="flex-o">
				<div class="name">{{data.name}}</div>
				<div class="price" v-if="data.price">¥<em>{{data.price}}</em></div>
				<div class="desc">
					<div class="df hal mt">
						<span>选择等级 :</span>
						<div class="flex-o pb">
							<div class="spec" :class="{ cur: data.chooseLevel==v.id }" v-for="(v,i) in data.level" @click="tapSpec('level',v.id)">{{v.name}}</div>
						</div>
					</div>
					<div class="df hal">
						<span>选择规格 :</span>
						<div class="flex-o pb">
							<div class="spec" :class="{ cur: data.chooseSpec==v.id }" v-for="(v,i) in data.spec" @click="tapSpec('spec',v.id)">{{v.name}}</div>
						</div>
					</div>
					<div class="df hal">
						<span>数量 :</span>
						<div class="num df">
							<em @click="tapSub(data)"></em>
							<input type="number" class="flex-o" v-model="data.num" @blur="numBlur(data)">
							<em @click="tapAdd(data)"></em>
						</div>
						<div class="uom">{{data.uom}}</div>
					</div>
				</div>
				<div class="btn" :class="{ no: data.stockMax==0 }" @click="tapBtn">加入购物车</div>
			</div>
		</div>
		
		<!-- 账期额度不足(废弃) -->
		<div class="box accountLack" v-if="type=='accountLack'">
			<div class="cap">额度不足</div>
			<div class="txt">
				<div>当前账号账期至{{data.date}}</div>
				<div>额度为 {{data.money}}</div>
				<span>请联系客服{{data.phone}}</span>
			</div>
			<div class="df war"> 
				<div class="btn" @click="tapBtn">确定</div>
			</div>
		</div>
		
		<!-- 账期倒计时(废弃) -->
		<div class="box accountCountdown" v-if="type=='accountCountdown'">
			<div class="close" @click="tapClose"></div>
			<div class="cap">尊敬的客户，您当前账户</div>
			<div class="txt">
				<div>您当前账期剩余<em>{{data.day}}</em>天，于<em>{{data.date}}</em>到期</div>
				<div>账期余额：<em>¥{{data.money}}</em></div>
				<span>是否确认订购此笔订单？</span>
			</div>
			<div class="end df cf wao hao">
				<div class="df wao hao"> 
					<div class="btn" @click="tapBtn(1)">再考虑下</div>
					<div class="btn" @click="tapBtn(2)">确定下单</div>
				</div>
				<span>想更多账期余额？联系客服{{data.phone}}</span>
			</div>
		</div>
		
		<!-- 下单成功 -->
		<div class="box orderSuccess" v-if="type=='orderSuccess'">
			<div class="close" @click="tapClose"></div>
			<div class="cap">下单成功</div>
			<!-- <div class="txt mt">您可在个人中心查看您的订单</div> -->
			<div class="txt mt">{{data.reason}}</div>
			<div class="txt df wao hao mt" v-if="data.phone">请联系客服<span>{{data.phone}}</span></div>
			<div class="btn" @click="tapBtn">查看订单详情</div>
		</div>
		
		<!-- 下单失败 -->
		<div class="box orderFail" v-if="type=='orderFail'">
			<div class="close" @click="tapClose"></div>
			<div class="cap">下单失败</div>
			<div class="txt mt">{{data.reason}}</div>
			<div class="txt df wao hao mt" v-if="data.phone">请联系客服<span>{{data.phone}}</span></div>
			<div class="btn" @click="tapBtn">返回首页</div>
		</div>
		
		<!-- 编辑资料 -->
		<div class="box editInfo" v-if="type=='editInfo'">
			<div class="title">编辑资料</div>
			<div class="close rt" @click="tapClose"></div>
			<div class="line df hao" :class="{ error: data.error.name }">
				<span>昵称 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入您的昵称" v-model="data.name"></div>
				<em v-if="data.error.name">{{data.error.name}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.company }">
				<span>单位名称 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入您的单位名称" v-model="data.company"></div>
				<em v-if="data.error.company">{{data.error.company}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.person }">
				<span>注册人名称 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入您的注册人名称" v-model="data.person"></div>
				<em v-if="data.error.person">{{data.error.person}}</em>
			</div>
			<div class="end df war hao">
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>
		
		<!-- 绑定SAP编码 -->
		<div class="box bindAccount" v-if="type=='bindAccount'">
			<div class="title">绑定SAP编码</div>
			<div class="close rt" @click="tapClose"></div>
			<div class="line df hao" :class="{ error: data.error.account }">
				<span>绑定编码 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入您的SAP编码" v-model="data.account"></div>
				<em v-if="data.error.account">{{data.error.account}}</em>
			</div>
			<div class="end df war hao">
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>
		
		<!-- 修改手机号码-->
		<div class="box editPhone" v-if="type=='editPhone'">
			<div class="title">手机号码</div>
			<div class="close rt" @click="tapClose"></div>
			<div class="line df hao" :class="{ error: data.error.phone }">
				<span>手机号码 :</span>
				<div class="flex-o" v-if="data.isValidate"><input type="text" placeholder="请输入手机号码" v-model="data.phone2"></div>
				<div class="flex-o" v-else>{{data.phone}}</div>
				<em v-if="data.error.phone">{{data.error.phone}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.code }">
				<span>验证码 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入验证码" v-model="data.code"></div>
				<div class="send df wao hao" @click="tapCode" v-if="sdcode_now==0">{{sdcode_times>0?'重新获取验证码':'获取验证码'}}</div>
				<div class="send df wao hao" v-else>{{sdcode_now}}秒后<br>可重新发送</div>
				<em v-if="data.error.code">{{data.error.code}}</em>
			</div>
			<div class="end df war hao">
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>
		
		<!-- 修改密码-->
		<div class="box editPass" v-if="type=='editPass'">
			<div class="title">修改密码</div>
			<div class="close rt" @click="tapClose"></div>
			<div class="line df hao" :class="{ error: data.error.phone }">
				<span>手机号码 :</span>
				<div class="flex-o">{{data.phone}}</div>
				<em v-if="data.error.phone">{{data.error.phone}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.code }">
				<span>验证码 :</span>
				<div class="flex-o"><input type="text" placeholder="请输入验证码" v-model="data.code"></div>
				<div class="send df wao hao" @click="tapCode" v-if="sdcode_now==0">{{sdcode_times>0?'重新获取验证码':'获取验证码'}}</div>
				<div class="send df wao hao" v-else>{{sdcode_now}}秒后<br>可重新发送</div>
				<em v-if="data.error.code">{{data.error.code}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.pass }">
				<span>新密码 :</span>
				<div class="flex-o"><input type="password" placeholder="请输入新密码" v-model="data.pass"></div>
				<em v-if="data.error.pass">{{data.error.pass}}</em>
			</div>
			<div class="line df hao" :class="{ error: data.error.pass2 }">
				<span>确认新密码 :</span>
				<div class="flex-o"><input type="password" placeholder="请输入新密码" v-model="data.pass2"></div>
				<em v-if="data.error.pass2">{{data.error.pass2}}</em>
			</div>
			<div class="end df war hao">
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>

		<!-- 取消订单 -->
		<div class="box cancelOrder" v-if="type=='cancelOrder'">
			<div class="cap">取消订单</div>
			<div class="txt">请确认是否取消订单</div>
			<div class="df war hao"> 
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>
		
		<!-- 修改订单 -->
		<div class="box editOrder" v-if="type=='editOrder'">
			<div class="close rt" @click="tapClose"></div>
			<div class="table">
				<table>
					<col style="width: 40.62%;">
					<col style="width: 16%;">
					<col style="width: 16%;">
					<col style="width: 27.38%;">
					<thead>
						<th>商品</th>
						<th>等级</th>
						<th>规格</th>
						<th>商品数量</th>
					</thead>
					<tbody>
						<tr v-for="(v,i) in data.list">
							<td>
								<div class="pd df hal">
									<img :src="v.img" alt="">
									<div class="flex-o">{{v.name}}</div>
								</div>
							</td>
							<td>{{v.level}}</td>
							<td>{{v.spec}}</td>
							<td>
								<div class="df wao hao">
									<div class="num df">
										<em @click="tapSub(v)"></em>
										<input type="number" class="flex-o" v-model="v.num" @blur="numBlur(v)">
										<em @click="tapAdd(v)"></em>
									</div>
									<div class="uom">{{v.uom}}</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="end df war hao">
				<div class="btn" @click="tapBtn(1)">取消</div>
				<div class="btn" @click="tapBtn(2)">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	let clock = null
	let codeOld = ''
	export default {
		name: 'floats',
		props: {},
		data () {
			return {
				sdcode_can: true, // 是否可发送验证码
				sdcode_times: 0, // 倒计时次数
				sdcode_max: 60, // 倒计时时间(s)
				sdcode_now: 0,
				isShow: true,
				type: '', // [chooseSpec 选择规格] [accountLack 账期额度不足] [accountCountdown 账期倒计时] [orderSuccess 下单成功] [orderFail 下单失败] [editInfo 编辑资料] [bindAccount 绑定SAP编码] [editPhone 修改手机号码] [editPass 修改密码] [editOrder 修改订单]
				data: {},
			}
		},
		methods: {
			add(type,data){
				this.sdcode_can = true
				this.sdcode_times = 0
				this.sdcode_max = 60
				this.sdcode_now = 0

				if(type=='chooseSpec'){ // 选择规格
					this.data = {
						id: data.id,
						img: '',
						name: '',
						price: '',
						uom: '',
						chooseLevel: '',
						level: [],
						chooseSpec: '',
						spec: [],
						specData: {},
						stockMax: 0,
						spec: [],
						num: 1,
					};
				
					// 获取商品基本信息
					this.$ajax.getShopDetail({
						goods_id: data.id,
					}).then(r=>{
						let img = r.carousel_images||[r.main_images]
						this.data.img = (img[0]||'')
						this.data.name = r.name
						
						let specData = {}
						r.goods_attr.forEach(v=>{
							specData[v.key] = {
								id: v.id,
								level: v.zmm_level, // sku等级
								spec: v.name, // sku规格
								price: v.price,
								uom: v.unit_name,
								stock: v.stock,
								desc: {
									p1: v.zspesc||'', // 品名
									p2: v.spec||'', // 装量
									p3: v.zmm_level||'', // 等级
									p4: v.zgmpprname||'', // 产地
									p5: v.maktx||'', // 规格
									p6: v.z_qu_std||'', // 执行标准
									p7: v.tax_rate||'', // 税率
								},
							}
						})
						this.data.specData = specData;
						
						let level = []
						r.spec.level.forEach(v=>{
							level.push({
								id: v,
								name: v||'　',
							})
						})
						this.data.level = level
						this.data.chooseLevel = level[0].id
						
						let spec = []
						r.spec.spec.forEach(v=>{
							spec.push({
								id: v,
								name: v,
							})
						})
						this.data.spec = spec
						this.data.chooseSpec = spec[0].id
						
						if(level.length==0){
							this.$alert({
								title: '暂无等级，请联系客服'
							}).then(()=>{})
							return
						}else if(spec.length==0){
							this.$alert({
								title: '暂无规格，请联系客服'
							}).then(()=>{})
							return
						}
						
						this.tapSpec('spec',spec[0].id)
					})
				// }else if(type=='accountLack'){ // 账期额度不足(废弃)
				// 	this.data = {
				// 		date: '2024-03-12',
				// 		money: '203.00',
				// 		phone: '020-88888888',
				// 	};
				// }else if(type=='accountCountdown'){ // 账期倒计时(废弃)
				// 	this.data = {
				// 		day: 20,
				// 		date: '2024年03月01日',
				// 		money: 10000,
				// 		phone: '020-88888888',
				// 	};
				}else if(type=='orderSuccess'){ // 下单成功
					this.data = {
						oid: data.oid,
						reason: data.reason,
						phone: data.phone,
					};
				}else if(type=='orderFail'){ // 下单失败
					this.data = {
						reason: data.reason,
						phone: data.phone,
					};
				}else if(type=='editInfo'){ // 编辑资料
					this.data = {
						name: this.$store.state.userinfo.name, // 昵称
						company: this.$store.state.userinfo.company, // 单位名称
						person: this.$store.state.userinfo.person, // 注册人名称
						error: {
							name: '',
							company: '',
							person: '',
						},
					};
				}else if(type=='bindAccount'){ // 绑定SAP编码
					this.data = {
						account: this.$store.state.userinfo.spa,
						error: {
							account: '',
						},
					};
				}else if(type=='editPhone'){ // 修改手机号码
					this.data = {
						isValidate: false, // 是否验证完旧号码
						phone: this.$store.state.userinfo.phone, // 旧号码
						phone2: '',
						code: '',
						error: {
							phone: '',
							code: '',
						},
					};
				}else if(type=='editPass'){ // 修改密码
					this.data = {
						phone: this.$store.state.userinfo.phone,
						code: '',
						pass: '',
						pass2: '',
						error: {
							phone: '',
							code: '',
							pass: '',
							pass2: '',
						},
					};
				}else if(type=='cancelOrder'){ // 取消订单
					this.data = {};
				}else if(type=='editOrder'){ // 修改订单
					this.data = {
						list: data.list,
					};
				}
				
				this.type = type
			},
			tapClose(isBtnClose){
				if(isBtnClose==1){
					if(this.type=='editPhone'){ // 修改手机号码
						return
					}else if(this.type=='editPass'){ // 修改密码
						return
					}
				}else{
					if(this.type=='orderSuccess'){ // 下单成功
						this.$api.toPage('my/order')
					}
				}
				
				this.type = '';
				this.data = {};
			},
			tapSpec(type,id){
				if(type=='level'){
					// if(this.data.chooseLevel==id){
					// 	return
					// }
					this.data.chooseLevel = id
				}else if(type=='spec'){
					// if(this.data.chooseSpec==id){
					// 	return
					// }
					this.data.chooseSpec = id
				}
				
				let data = this.data.specData[this.data.chooseLevel+'_'+this.data.chooseSpec]
				if(!data){
					// this.$ajax.getShopDetailAttrNone({
					// 	goods_id: this.data.id,
					// 	spec: this.data.chooseSpec,
					// }).then(r=>{
					// 	this.data.chooseLevel = r.level
					// 	this.data.chooseSpec = r.spec
					// 	this.tapSpec('spec',r.spec)
					// })
					// return
					data = {
						stock: 0,
						price: 0,
						desc: {
							p1: '',
							p2: '',
							p3: '',
							p4: '',
							p5: '',
							p6: '',
							p7: '',
						},
					}
				}
				
				this.data.stockMax = Number(data.stock||0)
				this.setSpec(data)
				
				if(this.data.num>this.data.stockMax){
					this.data.num = this.data.stockMax
				}else{
					this.data.num = 1
				}
			},
			setSpec(data){
				this.data.price = data.price
				this.data.uom = data.uom
			},
			tapSub(data){
				if(this.type=='chooseSpec'){ // 选择规格
					if(data.num<=1){
						return
					}
				}else if(this.type=='editOrder'){ // 修改订单
					if(data.num<=0){
						return
					}
				}
				data.num --
			},
			tapAdd(data){
				if(this.type=='chooseSpec'){ // 选择规格
					if(data.num>=data.stockMax){
						this.$alert({
							title: '库存不足，请联系客服',
						}).then(()=>{})
						data.num = data.stockMax
						return
					}
				}
				data.num ++
			},
			numBlur(data){
				if(this.type=='chooseSpec'){ // 选择规格
					if(data.num<1){
						data.num = 1
					}else if(data.num>data.stockMax){
						this.$alert({
							title: '库存不足，请联系客服',
						}).then(()=>{})
						data.num = data.stockMax
					}
				}else if(this.type=='editOrder'){ // 修改订单
					if(data.num<0){
						data.num = 0
					}
				}
			},
			tapCode(){
				this.emptyError()
				let phone = this.data.phone
				let stype = ''
				
				if(this.type=='editPhone'){
					stype = 'changemobile'
					if(this.data.isValidate){
						stype = 'changemobilenew'
						phone = this.data.phone2
					}
					
					if(phone==''){
						this.data.error.phone = '请输入手机号码'
						return
					}
				}else if(this.type=='editPass'){
					stype = 'changepwd'
					if(phone==''){
						this.data.error.phone = '请输入手机号码'
						return
					}
				}
				
				if(!this.sdcode_can){
					return
				}
				this.sdcode_can = false
				this.$ajax.sendCode({
					prefix: '86',
					mobile: phone,
					event: stype,
				}).then(r=>{
					this.sdcode_times ++
					this.sdcode_now = this.sdcode_max
					clock = setInterval(()=>{
						if(this.sdcode_now<=1){
							clearInterval(clock)
							this.sdcode_can = true
							clock = null
						}
						this.sdcode_now --
					},1000)
				}).catch(r=>{
					this.sdcode_can = true
				})
			},
			emptyError(){
				if(this.data.error){
					for(var i in this.data.error){
						this.data.error[i] = ''
					}
				}
			},
			tapBtn(tp){
				clearInterval(clock)
				clock = null
				this.sdcode_now = 0
				this.emptyError()
				
				if(this.type=='chooseSpec'){ // 选择规格
					// this.$parent && this.$parent.addShopcar && this.$parent.addShopcar();
					let data = this.data.specData[this.data.chooseLevel+'_'+this.data.chooseSpec]
					if(this.data.stockMax==0){
						this.$alert({
							title: '库存不足，请联系客服'
						}).then(()=>{})
						return
					}
					
					this.$ajax.addShopcar({
						goods_id: this.data.id,
						goods_sku_id: data.id,
						goods_num: this.data.num,
					}).then(r=>{
						data.stock -= this.data.num
						this.data.num = 1
						this.$alert({
							title: '成功加入购物车'
						}).then(()=>{})
						
						this.$store.commit('updateShopcar')
					})
				}else if(this.type=='accountCountdown'){ // 账期倒计时
					if(tp==2){
						this.$parent && this.$parent.accountCountdown && this.$parent.accountCountdown();
					}
				}else if(this.type=='orderSuccess'){ // 下单成功
					this.$api.toPage('order/detail',{
						id: this.data.oid,
					})
				}else if(this.type=='orderFail'){ // 下单失败
					this.$api.toPage('index')
				}else if(this.type=='editInfo'){ // 编辑资料
					if(tp==2){
						if(this.data.name==''){
							this.data.error.name = '请输入您的昵称'
							return
						}else if(this.data.company==''){
							this.data.error.company = '请输入您的单位名称'
							return
						}else if(this.data.person==''){
							this.data.error.person = '请输入您的注册人名称'
							return
						}
						
						this.$parent && this.$parent.updateInfo && this.$parent.updateInfo(this.data.name,this.data.company,this.data.person);
					}
				}else if(this.type=='bindAccount'){ // 绑定SAP编码
					if(tp==2){
						if(this.data.account==''){
							this.data.error.account = '请输入您的SAP编码'
							return
						}
						
						this.$parent && this.$parent.updateAccount && this.$parent.updateAccount(this.data.account);
					}
				}else if(this.type=='editPhone'){ // 修改手机号码
					this.sdcode_times = 0
					this.sdcode_can = true
					if(tp==2){
						if(!this.data.isValidate){ // 此处需验证旧手机号
							if(this.data.code==''){
								this.data.error.code = '请输入验证码'
								return
							}
							
							this.$ajax.checkCode({
								prefix: '86',
								mobile: this.data.phone,
								event: 'changemobile',
								code: this.data.code,
							}).then(r=>{
								codeOld = this.data.code
								this.data.isValidate = true;
								this.data.code = ''
								this.emptyError()
							})
							return
						}else{
							if(this.data.phone2==''){
								this.data.error.phone = '请输入手机号码'
								return
							}else if(this.data.code==''){
								this.data.error.code = '请输入验证码'
								return
							}
							
							this.$parent && this.$parent.updatePhone && this.$parent.updatePhone(this.data.phone2,codeOld,this.data.code,this.tapClose);
						}
					}else{
						this.tapClose()
					}
				}else if(this.type=='editPass'){ // 修改密码
					if(tp==2){
						if(this.data.code==''){
							this.data.error.code = '请输入验证码'
							return
						}else if(this.data.pass==''){
							this.data.error.pass = '请输入新密码'
							return
						}else if(this.data.pass!=this.data.pass2){
							this.data.error.pass2 = '两次输入的密码不一致'
							return
						}
						
						this.$parent && this.$parent.updatePass && this.$parent.updatePass(this.data.phone,this.data.code,this.data.pass,this.tapClose);
					}else{
						this.tapClose()
					}
				}else if(this.type=='cancelOrder'){ // 取消订单
					if(tp==2){
						this.$parent && this.$parent.cancelOrder && this.$parent.cancelOrder();
					}
				}else if(this.type=='editOrder'){ // 修改订单
					if(tp==2){
						this.$parent && this.$parent.editOrder && this.$parent.editOrder(this.data.list);
					}
				}
				
				this.tapClose(1)
			},
		},
	}
</script>

<style lang="less" scoped>
	.floats {
		background: rgba(0,0,0,0.5);
		position: fixed;
		z-index: 9990;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		.box{
			background: #FFFFFF;
			box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);
			border-radius: 4px 4px 4px 4px;
			position: relative;
		}
		.close{
			width: 40px;
			height: 40px;
			position: absolute;
			top: 8px;
			right: 12px;
			cursor: pointer;
			background: url(../../assets/img/close.png) center center / 16px auto no-repeat;
			&.rt{
				top: 4px;
				right: 8px;
			}
		}
		.chooseSpec{
			width: 640px;
			padding: 48px 50px 24px 50px;
			img{
				width: 200px;
				height: 200px;
				object-fit: cover;
				margin-right: 42px;
			}
			.name{
				font-family: PingFang SC, PingFang SC;
				font-weight: 600;
				font-size: 20px;
				color: #000000;
				line-height: 28px;
			}
			.price{
				font-family: PingFang SC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				color: #E73363;
				line-height: 42px;
				height: 42px;
				margin-top: 16px;
				em{
					font-size: 30px;
				}
			}
			.desc{
				margin-top: 24px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #666666;
				line-height: 36px;
				span{
					width: 70px;
					margin-right: 6px;
				}
				.mt{
					margin-top: 12px;
				}
				.pb{
					padding-bottom: 14px;
				}
			}
			.spec{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #4C4C4C;
				line-height: 18px;
				float: left;
				padding: 8px 11px;
				background: #F0F0F0;
				border: 1px solid #f0f0f0;
				border-radius: 2px;
				margin-right: 10px;
				margin-bottom: 10px;
				cursor: pointer;
				&.cur{
					border-color: #e73363;
					color: #e73363;
				}
			}
			.num{
				width: 126px;
				height: 38px;
				border: 1px solid #B0B0B0;
				overflow: hidden;
				input{
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #000000;
					line-height: 22px;
					height: 36px;
					border: 0;
					text-align: center;
				}
				em{
					cursor: pointer;
					width: 36px;
					height: 36px;
					&:first-child{
						width: 37px;
						border-right: 1px solid #B0B0B0;
						background: url(../../assets/img/sub2.png) center center / 100% auto no-repeat;
					}
					&:last-child{
						width: 37px;
						border-left: 1px solid #B0B0B0;
						background: url(../../assets/img/add2.png) center center / 100% auto no-repeat;
					}
				}
			}
			.uom{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #666666;
				line-height: 36px;
				margin-left: 12px;
			}
			.btn{
				width: 152px;
				background: #E73363;
				border-radius: 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 48px;
				text-align: center;
				margin-top: 24px;
				&.no{
					background: #bdbdbd;
				}
			}
		}
		.accountLack{
			width: 416px;
			padding: 32px 32px 24px 32px ;
			.cap{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
				line-height: 24px;
				background: url(../../assets/img/imp.png) left center / 22px auto no-repeat;
				padding-left: 38px;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: rgba(0,0,0,0.85);
				line-height: 22px;
				padding-left: 38px;
				margin-top: 8px;
				span{
					color: #7F7F7F;
				}
			}
			.btn{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 42px;
				width: 116px;
				background: #009B73;
				box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
				border-radius: 2px;
				text-align: center;
				margin-top: 24px;
			}
		}
		.accountCountdown{
			width: 416px;
			padding: 24px 20px 0 20px;
			.cap{
				font-family: PingFang SC, PingFang SC;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				line-height: 21px;
			}
			.txt{
				margin-top: 16px;
				margin-bottom: 24px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
				line-height: 26px;
				em{
					color: #F68800;
				}
				span{
					margin-top: 8px;
					display: block;
				}
			}
			.end{
				margin: 0 -20px;
				height: 94px;
				border-top: 1px solid #E5E6EB;
				span{
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 12px;
					color: #999999;
					line-height: 26px;
					margin-top: 4px;
				}
			}
			.btn{
				width: 112px;
				background: #009B73;
				border-radius: 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: center;
				&:first-child{
					margin-right: 8px;
					background: #f2f3f5;
					color: #4E5969;
				}
			}
		}
		.orderSuccess{
			min-width: 416px;
			max-width: 800px;
			padding: 24px;
			.cap{
				padding-top: 64px;
				background: url(../../assets/img/success.png) top center / 48px auto no-repeat;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #1D2129;
				line-height: 22px;
				text-align: center;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 22px;
				text-align: center;
				&.mt{
					margin-top: 10px;
				}
				span{
					color: #7F7F7F;
					display: block;
				}
			}
			.btn{
				width: 140px;
				background: #009B73;
				border-radius: 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: center;
				margin: 16px auto 0 auto;
			}
		}
		.orderFail{
			min-width: 416px;
			max-width: 800px;
			padding: 24px;
			.cap{
				padding-top: 64px;
				background: url(../../assets/img/fail.png) top center / 48px auto no-repeat;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #000000;
				line-height: 22px;
				text-align: center;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 22px;
				text-align: center;
				&.mt{
					margin-top: 10px;
				}
				span{
					color: #7F7F7F;
					display: block;
				}
			}
			.btn{
				width: 140px;
				background: #009B73;
				border-radius: 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: center;
				margin: 16px auto 0 auto;
			}
		}
		.editInfo, .bindAccount, .editPhone, .editPass{
			width: 520px;
			.title{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #1D2129;
				line-height: 48px;
				padding: 0 20px;
				border-bottom: 1px solid #E5E6EB;
				margin-bottom: 24px;
			}
			.line{
				padding-bottom: 16px;
				margin-right: 42px;
				position: relative;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 22px;
				span{
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					line-height: 22px;
					width: 102px;
					text-align: right;
					margin-right: 16px;
				}
				input{
					width: 100%;
					background: #F5F5F5;
					border-radius: 2px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333;
					line-height: 22px;
					height: 36px;
					border: 1px solid #f5f5f5;
					padding: 0 16px;
				}
				em{
					position: absolute;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #DA3B71;
					line-height: 20px;
					left: 118px;
					top: 36px;
				}
				.send{
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 16px;
					text-align: center;
					height: 36px;
					width: 102px;
					background: #009B73;
					border-radius: 2px;
					cursor: pointer;
					margin-left: 8px;
				}
				&.error{
					padding-bottom: 24px;
					input{
						border-color: #DA3B71;
					}
				}
			}
			.end{
				border-top: 1px solid #E5E6EB;
				margin-top: 12px;
				height: 64px;
				padding: 0 20px;
			}
			.btn{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				width: 60px;
				background: #009B73;
				border-radius: 2px;
				text-align: center;
				margin-left: 8px;
				&:first-child{
					background: #f5f5f5;
					color: #4C4C4C;
				}
			}
		}
		.cancelOrder{
			width: 416px;
			padding: 32px 32px 24px 32px ;
			.cap{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
				line-height: 24px;
				background: url(../../assets/img/imp.png) left center / 22px auto no-repeat;
				padding-left: 38px;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: rgba(0,0,0,0.85);
				line-height: 22px;
				padding-left: 38px;
				margin-top: 8px;
			}
			.btn{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				width: 60px;
				background: #009B73;
				box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
				border-radius: 2px;
				text-align: center;
				margin-top: 24px;
				margin-left: 8px;
				&:first-child{
					background: #fff;
					color: rgba(0,0,0,0.85);
					border-radius: 2px 2px 2px 2px;
					border: 1px solid #D9D9D9;
				}
			}
		}
		.editOrder{
			width: 688px;
			.table{
				background: #fff;
				padding: 48px 24px 0 24px;
				table{
					width: 100%;
					border-collapse: collapse;
					table-layout: fixed;
					thead{}
					th{
						background: #f5f5f5;
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #000000;
						line-height: 15px;
						text-align: center;
						font-weight: normal;
						height: 38px;
					}
					tbody{}
					tr{
						border-right: 1px solid #e1e1e1;
					}
					td{
						border: 1px solid #e1e1e1;
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 13px;
						color: #000000;
						line-height: 15px;
						text-align: center;
						padding: 18px;
						vertical-align: top;
					}
				}
				.pd{
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #000000;
					line-height: 15px;
					text-align: left;
					img{
						width: 64px;
						height: 64px;
						object-fit: cover;
						margin-right: 12px;
					}
				}
				.num{
					width: 126px;
					height: 36px;
					border: 1px solid #B0B0B0;
					overflow: hidden;
					input{
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 16px;
						color: #000000;
						line-height: 22px;
						height: 36px;
						border: 0;
						text-align: center;
					}
					em{
						cursor: pointer;
						width: 36px;
						height: 36px;
						&:first-child{
							border-right: 1px solid #B0B0B0;
							background: url(../../assets/img/sub2.png) center center / 100% auto no-repeat;
						}
						&:last-child{
							border-left: 1px solid #B0B0B0;
							background: url(../../assets/img/add2.png) center center / 100% auto no-repeat;
						}
					}
				}
				.uom{
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #666666;
					line-height: 36px;
					margin-left: 12px;
				}
			}
			.end{
				padding: 0 24px;
				height: 64px;
				.btn{
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 32px;
					width: 60px;
					background: #e73363;
					box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
					border-radius: 2px;
					text-align: center;
					margin-left: 8px;
					&:first-child{
						background: #fff;
						color: rgba(0,0,0,0.85);
						border-radius: 2px 2px 2px 2px;
						border: 1px solid #D9D9D9;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/floats/floats.vue